import api from "./api";

const reportJwtBasePath = "/api/v1/report-jwt";

export async function getReportJwt({ tz, walletClientId }) {
  const { data } = await api.get(reportJwtBasePath, {
    params: {
      tz,
      walletClientId,
    },
  });
  return data;
}
